// import trace from "../../../helpers/trace";
import moment from "moment";

import {
  createSolicitudApi, deleteSolicitudApi, sendReminderApi,
  getSolicitudesApi,
  createSolicitudADApi,
  deleteSolicitudADApi,
  sendAdRemainderApi,
} from "../../../../../services/solicitudesApi";
import { allRolesByProfileId, getRolesByCompanyRutAndUser } from '../../../../../services/userRolesApi'
import { getAllProfiles } from '../../../../../services/perfilesApi'

import { openCloseToast, sendEmailApp } from "../../../../Global/actions";
import { store } from "../../../../../config/store";
import trace from "../../../../../helpers/trace";
import constants from '../../../../../helpers/constants';

export const loading = (isLoading) => ({
  type: "LOADING_SOLICITUDES",
  isLoading,
});

export const loadSolicitudes = (solicitudes) => ({
  type: "LOAD_SOLICITUDES",
  solicitudes,
});

export const setErrorCompanyRut = (message) => ({
  type: "SET_ERROR_COMPANY_RUT",
  message,
});

export const setRolesEmpresa = (roles) => ({
  type: "SET_ROLES_EMPRESA",
  roles,
});

export const setRolesCurrentUser = (roles) => ({
  type: "SET_ROLES_CURRENT_USER",
  roles,
});

export const doGetSolicitudes = (rutUser) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const response = await getSolicitudesApi(rutUser);
    if (response.ok) {
      const result = await response.json();
      const data = result.Data.map((item) => ({
        ...item,
        LastReminderDate: moment.utc(item.LastReminderDate).local().format(),
      }));
      dispatch(loadSolicitudes(data));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al cargar las solicitudes",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    trace.error("doGetSolicitudes", e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al cargar las solicitudes",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doSendNewSolicitud = ({ rutEmpresa, userInfo, role, permits }) => async (dispatch) => {
  dispatch(loading(true));
  dispatch(setErrorCompanyRut(null));
  try {
    let response;
    if (userInfo.TempBD) {
      response = await createSolicitudApi(userInfo.RUT, rutEmpresa, '', role, permits);
      // ENVIO DE CORREO
      const parametersMail = {};
      parametersMail.userInfo = {
        FirstName: userInfo.FirstName,
        LastName: userInfo.LastName,
        Email: userInfo.Email,
        Rut: userInfo.RUT,
        rutEmpresa,
      };
      parametersMail.templateMail = "bienvenidaTemporal";
      if (response.status === 200) {
        await dispatch(sendEmailApp(parametersMail));
      }
    } else {
      // To do: Se debe borrar la opción de descripción cuando backend lo modifique
      response = await createSolicitudADApi(userInfo.RUT, rutEmpresa, 'descripcion ...', role, permits);
    }

    if (response.status === 200) {
      dispatch(doGetSolicitudes(userInfo.RUT));
      dispatch(setErrorCompanyRut(false));
      // envío correo
    } else {
      const result = await response.json();
      dispatch(setErrorCompanyRut(result.Message));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al crear la nueva solicitud",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doDeleteSolicitud = (rut, idSolicitud, FromUserAD) => async (dispatch) => {
  try {
    let response;
    if (FromUserAD) {
      response = await deleteSolicitudADApi(rut, idSolicitud);
    } else {
      response = await deleteSolicitudApi(rut, idSolicitud);
    }
    if (response.status === 200) {
      dispatch(doGetSolicitudes(rut));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al borrar la solicitud",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al borrar la solicitud",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
};

export const doResendSolicitud = (idSolicitud, fromUser) => async (dispatch) => {
  try {
    let response;

    if (fromUser) response = await sendAdRemainderApi(idSolicitud);
    else response = await sendReminderApi(idSolicitud, fromUser);

    if (response.ok) {
      const { userData } = store.getState().global;
      dispatch(doGetSolicitudes(userData.RUT));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al reenviar la solicitud",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al reenviar la solicitud",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
};

export const getRolesPortalEmpresa = () => async (dispatch) => {
  let roles = [];

  const profiles = await getAllProfiles();

  if (profiles.status === 200) {
    const profileJson = await profiles.json();

    if (profileJson.Data && profileJson.Data.length) {
      const enterpriseProfile = profileJson.Data.find(profile => profile.Code === constants.codePerfilEmpresa);

      if (enterpriseProfile) {
        const enterpriseRoles = await allRolesByProfileId(enterpriseProfile.Id);

        if (enterpriseRoles.status === 200) {
          const rolesJson = await enterpriseRoles.json();

          if (rolesJson.Data && rolesJson.Data.length) {
            roles = rolesJson.Data.map(item => ( {
                Id: item.Id,
                Name: item.Name,
                Description: item.Description,
            }));
          }
        }
      }
    }
  }

  dispatch(setRolesEmpresa(roles))
}

export const getRolesFromUserAndCompany = (company, rut) => async (dispatch) => {
  dispatch(loading(true));
  let roles = [];

  try {
    const request = await getRolesByCompanyRutAndUser(company, rut);

    if (request.status === 200) {
      const result = await request.json();

      if (result.Employees && result.Employees.length) {
        result.Employees.forEach(employee => {

          if (employee.Roles && employee.Roles.length) {
            employee.Roles.forEach(rol => {
              roles.push(rol.Id)
            })
          }
        });
      }
    }
  } catch (error) {
    trace.information("ERROR", error);
    const toast = {
      isToastOpen: true,
      msgToast: 'Error de conexión, intente mas tarde',
      typeStyle: 'error',
      displayTime: 5000
    }
    dispatch(openCloseToast(toast));
  }

  dispatch(setRolesCurrentUser(roles));
  dispatch(loading(false));
}
